"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCJSPluginDefinition = exports.isESMPluginDefinition = exports.isUMDPluginDefinition = void 0;
var load_script2_1 = __importDefault(require("load-script2"));
// locals
var Plugin_1 = __importDefault(require("./Plugin"));
var ReExports_1 = __importDefault(require("./ReExports"));
var util_1 = require("./util");
function isUMDPluginDefinition(def) {
  return (def.umdUrl !== undefined || def.url !== undefined || def.umdLoc !== undefined) && def.name !== undefined;
}
exports.isUMDPluginDefinition = isUMDPluginDefinition;
function isESMPluginDefinition(def) {
  return def.esmUrl !== undefined || def.esmLoc !== undefined;
}
exports.isESMPluginDefinition = isESMPluginDefinition;
function isCJSPluginDefinition(def) {
  return def.cjsUrl !== undefined;
}
exports.isCJSPluginDefinition = isCJSPluginDefinition;
function isInWebWorker() {
  return Boolean('WorkerGlobalScope' in globalThis);
}
var PluginLoader = /*#__PURE__*/function () {
  function PluginLoader() {
    var defs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var args = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, PluginLoader);
    this.definitions = [];
    this.fetchESM = args === null || args === void 0 ? void 0 : args.fetchESM;
    this.fetchCJS = args === null || args === void 0 ? void 0 : args.fetchCJS;
    this.definitions = JSON.parse(JSON.stringify(defs));
  }
  _createClass(PluginLoader, [{
    key: "loadScript",
    value: function () {
      var _loadScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(scriptUrl) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (isInWebWorker()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", (0, load_script2_1.default)(scriptUrl));
            case 2:
              if (!(globalThis === null || globalThis === void 0 ? void 0 : globalThis.importScripts)) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return globalThis.importScripts(scriptUrl);
            case 5:
              return _context.abrupt("return");
            case 6:
              throw new Error('cannot figure out how to load external JS scripts in this environment');
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function loadScript(_x) {
        return _loadScript.apply(this, arguments);
      }
      return loadScript;
    }()
  }, {
    key: "loadCJSPlugin",
    value: function () {
      var _loadCJSPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(def, baseUri) {
        var parsedUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              parsedUrl = new URL(def.cjsUrl, baseUri);
              if (!(parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:')) {
                _context2.next = 3;
                break;
              }
              throw new Error("Cannot load plugins using protocol \"".concat(parsedUrl.protocol, "\""));
            case 3:
              if (this.fetchCJS) {
                _context2.next = 5;
                break;
              }
              throw new Error('No fetchCJS callback provided');
            case 5:
              return _context2.abrupt("return", this.fetchCJS(parsedUrl.href));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadCJSPlugin(_x2, _x3) {
        return _loadCJSPlugin.apply(this, arguments);
      }
      return loadCJSPlugin;
    }()
  }, {
    key: "loadESMPlugin",
    value: function () {
      var _loadESMPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(def, baseUri) {
        var parsedUrl, plugin;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              parsedUrl = 'esmUrl' in def ? new URL(def.esmUrl, baseUri) : new URL(def.esmLoc.uri, def.esmLoc.baseUri);
              if (!(parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:')) {
                _context3.next = 3;
                break;
              }
              throw new Error("cannot load plugins using protocol \"".concat(parsedUrl.protocol, "\""));
            case 3:
              if (this.fetchESM) {
                _context3.next = 5;
                break;
              }
              throw new Error("No ESM fetcher installed");
            case 5:
              _context3.next = 7;
              return this.fetchESM(parsedUrl.href);
            case 7:
              plugin = _context3.sent;
              if (plugin) {
                _context3.next = 10;
                break;
              }
              throw new Error("Could not load ESM plugin: ".concat(parsedUrl));
            case 10:
              return _context3.abrupt("return", plugin);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadESMPlugin(_x4, _x5) {
        return _loadESMPlugin.apply(this, arguments);
      }
      return loadESMPlugin;
    }()
  }, {
    key: "loadUMDPlugin",
    value: function () {
      var _loadUMDPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(def, baseUri) {
        var parsedUrl, moduleName, umdName, plugin;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              parsedUrl = 'url' in def ? new URL(def.url, baseUri) : 'umdUrl' in def ? new URL(def.umdUrl, baseUri) : new URL(def.umdLoc.uri, def.umdLoc.baseUri);
              if (!(parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:')) {
                _context4.next = 3;
                break;
              }
              throw new Error("cannot load plugins using protocol \"".concat(parsedUrl.protocol, "\""));
            case 3:
              moduleName = def.name;
              umdName = "JBrowsePlugin".concat(moduleName);
              if (!(typeof jest !== 'undefined')) {
                _context4.next = 9;
                break;
              }
              // @ts-ignore
              globalThis[umdName] = {
                default: Plugin_1.default
              };
              _context4.next = 11;
              break;
            case 9:
              _context4.next = 11;
              return this.loadScript(parsedUrl.href);
            case 11:
              // @ts-ignore
              plugin = globalThis[umdName];
              if (plugin) {
                _context4.next = 14;
                break;
              }
              throw new Error("Failed to load UMD bundle for ".concat(moduleName, ", ").concat(umdName, " is undefined"));
            case 14:
              return _context4.abrupt("return", plugin);
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function loadUMDPlugin(_x6, _x7) {
        return _loadUMDPlugin.apply(this, arguments);
      }
      return loadUMDPlugin;
    }()
  }, {
    key: "loadPlugin",
    value: function () {
      var _loadPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(def, baseUri) {
        var plugin;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(util_1.isElectron && isCJSPluginDefinition(def))) {
                _context5.next = 6;
                break;
              }
              _context5.next = 3;
              return this.loadCJSPlugin(def, baseUri);
            case 3:
              plugin = _context5.sent;
              _context5.next = 23;
              break;
            case 6:
              if (!isESMPluginDefinition(def)) {
                _context5.next = 12;
                break;
              }
              _context5.next = 9;
              return this.loadESMPlugin(def, baseUri);
            case 9:
              plugin = _context5.sent;
              _context5.next = 23;
              break;
            case 12:
              if (!isUMDPluginDefinition(def)) {
                _context5.next = 18;
                break;
              }
              _context5.next = 15;
              return this.loadUMDPlugin(def, baseUri);
            case 15:
              plugin = _context5.sent;
              _context5.next = 23;
              break;
            case 18:
              if (!(!util_1.isElectron && isCJSPluginDefinition(def))) {
                _context5.next = 22;
                break;
              }
              throw new Error("CommonJS plugin found, but not in a NodeJS environment: ".concat(JSON.stringify(def)));
            case 22:
              throw new Error("Could not determine plugin type: ".concat(JSON.stringify(def)));
            case 23:
              return _context5.abrupt("return", plugin.default);
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loadPlugin(_x8, _x9) {
        return _loadPlugin.apply(this, arguments);
      }
      return loadPlugin;
    }()
  }, {
    key: "installGlobalReExports",
    value: function installGlobalReExports(target) {
      // @ts-ignore
      target.JBrowseExports = Object.fromEntries(Object.entries(ReExports_1.default).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          moduleName = _ref2[0],
          module = _ref2[1];
        return [moduleName, module];
      }));
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(baseUri) {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", Promise.all(this.definitions.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(definition) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return _this.loadPlugin(definition, baseUri);
                      case 2:
                        _context6.t0 = _context6.sent;
                        _context6.t1 = definition;
                        return _context6.abrupt("return", {
                          plugin: _context6.t0,
                          definition: _context6.t1
                        });
                      case 5:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x11) {
                  return _ref3.apply(this, arguments);
                };
              }())));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function load(_x10) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }]);
  return PluginLoader;
}();
exports.default = PluginLoader;